import React from "react";

export const BUSINESS_PLAN: Plan = {
    key: "business",
    label: 'BUSINESS',
    buttonType: "trial",
    description: 'Up to 50 users',
    price: 9,
    minTeamSize: 11,
    maxTeamSize: 50,
    defaultTeamSize: 50,
    recommended: true,
    freeModeAllowed: false,
    featuresTitle: 'Everything in PLUS, and:',
    features: [
        'Invoicing',
        'Compliance reporting',
        'Role-based access',
        'Workload analysis',
        'Project forecasting',
        'Uninvoiced time'
    ],
} as const

export const PRICE_PLANS: Plan[] = [
    {
        key: "free",
        label: 'FREE',
        buttonType: "free",
        description: 'Up to 3 users • 1 project',
        price: 0,
        minTeamSize: 1,
        maxTeamSize: 3,
        defaultTeamSize: 3,
        freeModeAllowed: true,
        featuresTitle: 'Features:',
        features: [
            'Time tracking (web, desktop, browser)',
            'Timer & manual entries',
            'Tasks',
            'Timesheets',
            'Billable & non-billable time',
            'Billable & cost rates',
            'Reports & project financials',
            'Time-off calendar'
        ],
    },
    {
        key: "plus",
        label: 'PLUS',
        buttonType: "trial",
        description: 'Up to 10 users',
        price: 4,
        minTeamSize: 4,
        maxTeamSize: 10,
        defaultTeamSize: 10,
        freeModeAllowed: true,
        featuresTitle: 'Everything in FREE, and:',
        features: [
            'Unlimited projects',
            'Client management',
            'Break tracking',
            'Work-related expenses',
            'Email support'
        ],
    },
    BUSINESS_PLAN,
    {
        key: "scale",
        label: 'SCALE',
        buttonType: "trial",
        description: 'Up to 300 users',
        price: 13,
        minTeamSize: 51,
        maxTeamSize: 300,
        defaultTeamSize: 300,
        freeModeAllowed: false,
        featuresTitle: 'Everything in BUSINESS, and:',
        features: [
            'More user seats',
            'Focus & distractions',
            'Burnout radar'
        ],
    },
    {
        key: "enterprise",
        label: 'ENTERPRISE',
        buttonType: "sales",
        description: 'For teams of 300+',
        price: "Custom quote",
        minTeamSize: 301,
        maxTeamSize: false,
        freeModeAllowed: false,
        featuresTitle: "Everything in SCALE, and:",
        features: [
            "Custom integrations on request",
            "Dedicated customer success manager",
            "Isolated virtual server",
            "Audit logs"
        ],
    }
] as const

export type StartButtonType = "free" | "trial" | "sales"

export type Plan = {
    key: string
    label: React.ReactNode
    buttonType: StartButtonType
    recommended?: boolean
    description: React.ReactNode
    price: number | string
    minTeamSize: number
    maxTeamSize: number | false
    defaultTeamSize?: number,
    freeModeAllowed: boolean
    featuresTitle?: React.ReactNode
    features: string[]
}
